import React, {useState} from 'react';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {FormattedMessage} from "react-intl";
import Typography from "@mui/material/Typography";

import './ResetPasswordPopUp.style.scss';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";

const ResetPasswordPopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options, data}) => {
    const [email, setEmail] = useState('');

    const handleSubmitRequest = () => {
        console.log("Submit Request");
    }

    return (
        <Dialog open={open} onClose={onClose} className={"ResetPasswordPopUp"}>
            <DialogContent className={"resetPasswordContent"}>
                <div className={"closeButton"} onClick={onClose}>X</div>
                <Typography variant="h5" className={"title"}>
                    <FormattedMessage id={"popUp.resetPassword.title"}/>
                </Typography>
                <div className="emailInput">
                    <label>
                        <FormattedMessage id={"popUp.resetPassword.enterYourEmail"}/>
                    </label>
                    <input
                        className="email"
                        type="text"
                        placeholder="Enter Your Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <DialogActions className={"dialogActions"}>
                    <Button onClick={() => {
                    }} variant="contained" className={"submitRequest"}>
                        <FormattedMessage id={"popUp.resetPassword.submitRequest"}/>
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}

export default ResetPasswordPopUp;